/**
 * created by lei lei
 * 栏目切换来源
 */
import React, {Component} from 'react';
import {Modal} from "antd";
import "./VideoUpload.scss"
import VideoLocally from "../videoLocally/VideoLocally"
import {message} from "antd";

export default class VideoUpload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            uploadFileList: [],
        };
    }

    render() {
        const {videoUpload,handleOk,handleCancel} = this.props;
        const {uploadFileList} = this.state;
        return(
            <Modal
                title="本地上传"
                visible={videoUpload}
                onCancel={handleCancel}
                width={958}
                onOk={()=>{
                    let fileList = uploadFileList;
                    for(let i = 0 ; fileList && i < fileList.length; i++){
                        let item = fileList[i];
                        if(item.uid){//说明是刚上传的
                            if(item.status!="done"){
                                message.destroy();
                                message.warn({content: `视频尚未上传完成！`});
                                return;
                            }
                        }
                    }
                    if(this.videoLocally){
                        fileList.map(file => {
                            if(file.response){
                                file.url = file.response.mp4Path;
                                file.videoPic = file.response.thumbnailsPath;
                                file.playUrl = file.response.thumbnailsPlayPath;
                                file.duration = file.response.duration;
                                file.cssWidth = this.videoLocally.state.cssWidth;
                                file.cssHeight = this.videoLocally.state.cssHeight;
                                file.cssAutoPlay = this.videoLocally.state.cssAutoPlay;
                                file.float = this.videoLocally.state.float;
                            }
                        })
                    }
                    handleOk(fileList)
                }}
                bodyStyle={{padding:0}}
                maskClosable={false}
            >
                <div className="interval">
                    <VideoLocally ref={videoLocally=>this.videoLocally=videoLocally} onChange={(uploadFileList)=>{
                        this.setState({uploadFileList})
                    }} />
                </div>
            </Modal>
        )
    }
}